import { getStoredSessionUser } from '../../../app/services/session.service';
import { allowLocalDocumentsSnapshotFallback } from '../../../app/config/runtime-environment';

const DOCUMENTS_STORAGE_KEY = 'crm.documents.library';

function resolveDocumentsStorageKey() {
  const tenantId = String(getStoredSessionUser()?.tenantId || '').trim();

  return tenantId ? `${DOCUMENTS_STORAGE_KEY}.${tenantId}` : DOCUMENTS_STORAGE_KEY;
}

function canUseLocalStorage() {
  return typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';
}

export function readDocumentsStorage() {
  if (!canUseLocalStorage() || !allowLocalDocumentsSnapshotFallback()) return null;

  return window.localStorage.getItem(resolveDocumentsStorageKey());
}

export function writeDocumentsStorage(payload) {
  if (!canUseLocalStorage()) {
    throw new Error('DOCUMENTS_STORAGE_UNAVAILABLE');
  }

  window.localStorage.setItem(resolveDocumentsStorageKey(), payload);
}

export function clearDocumentsStorage() {
  if (!canUseLocalStorage()) return;

  window.localStorage.removeItem(resolveDocumentsStorageKey());
}
